// extracted by mini-css-extract-plugin
module.exports = {"dialogPrivacy":"DialogPrivacy_dialogPrivacy_2C7oz"};